"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLastTradingDay = calculateLastTradingDay;
exports.calculateLastTradingDayWithHolidays = calculateLastTradingDayWithHolidays;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
/**
 * Calculates the last trading day for short-dated options on new crop futures.
 *
 * The last day of trading is the last Friday which precedes by at least two business days
 * the last business day of the calendar month preceding the option's named expiry month.
 *
 * @param expiryMonth - The named expiry month of the option
 * @returns The last trading date for the option
 */
function calculateLastTradingDay(expiryMoment) {
    // Get the month preceding the expiry month
    const precedingMonth = expiryMoment.clone().subtract(1, 'month');
    // Find the last business day of the preceding month
    let lastBusinessDay = precedingMonth.clone().endOf('month');
    // Move backwards to find the last business day (Mon-Fri)
    while (lastBusinessDay.day() === 0 || lastBusinessDay.day() === 6) {
        lastBusinessDay.subtract(1, 'day');
    }
    // Go back 2 business days from the last business day
    let daysToSubtract = 2;
    let targetDate = lastBusinessDay.clone();
    while (daysToSubtract > 0) {
        targetDate.subtract(1, 'day');
        // Only count weekdays (Monday = 1, Friday = 5)
        if (targetDate.day() !== 0 && targetDate.day() !== 6) {
            daysToSubtract--;
        }
    }
    // Now find the last Friday that is on or before this target date
    let lastFriday = targetDate.clone();
    // If the target date is after Friday (Saturday = 6 or Sunday = 0),
    // go back to the previous Friday
    if (lastFriday.day() === 6) {
        lastFriday.subtract(1, 'day'); // Saturday to Friday
    }
    else if (lastFriday.day() === 0) {
        lastFriday.subtract(2, 'days'); // Sunday to Friday
    }
    else if (lastFriday.day() < 5) {
        // If it's Monday (1) through Thursday (4), go back to previous Friday
        const daysFromFriday = 5 - lastFriday.day();
        lastFriday.subtract(7 - daysFromFriday, 'days');
    }
    // If it's already Friday (5), we keep it as is
    return lastFriday.toDate();
}
/**
 * Alternative implementation with more explicit business day handling
 * Useful if you need to account for holidays
 */
function calculateLastTradingDayWithHolidays(expiryMonth, holidays = []) {
    const expiryMoment = (0, moment_timezone_1.default)(expiryMonth);
    const precedingMonth = expiryMoment.clone().subtract(1, 'month');
    // Helper function to check if a date is a business day
    const isBusinessDay = (date) => {
        // Check if it's a weekend
        if (date.day() === 0 || date.day() === 6) {
            return false;
        }
        // Check if it's a holiday
        const dateStr = date.format('YYYY-MM-DD');
        return !holidays.some(holiday => (0, moment_timezone_1.default)(holiday).format('YYYY-MM-DD') === dateStr);
    };
    // Find the last business day of the preceding month
    let lastBusinessDay = precedingMonth.clone().endOf('month');
    while (!isBusinessDay(lastBusinessDay)) {
        lastBusinessDay.subtract(1, 'day');
    }
    // Go back 2 business days
    let businessDaysCount = 0;
    let targetDate = lastBusinessDay.clone();
    while (businessDaysCount < 2) {
        targetDate.subtract(1, 'day');
        if (isBusinessDay(targetDate)) {
            businessDaysCount++;
        }
    }
    // Find the last Friday on or before the target date
    let lastFriday = targetDate.clone();
    while (lastFriday.day() !== 5) {
        lastFriday.subtract(1, 'day');
    }
    return lastFriday.toDate();
}
